module.exports = __webpack_public_path__ + "static/img/one_time_purchase.57c7a92.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/buy_more/one_time_purchase.png
// module id = n1uR
// module chunks = 1